import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './index';
import { thunk } from 'redux-thunk';

const persistConfig = {
    key: 'root',
    storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) =>
        // getDefaultMiddleware().concat(thunk)
    getDefaultMiddleware({
        serializableCheck:{
            ignoredActions:['persist/PERSIST']
        }
    })
});

export const persistor = persistStore(store);


export default store